import axios from 'axios';

export const VTAPI = (token) => {
    
    const instance = axios.create(
        {
            baseURL : process.env.REACT_APP_VT_API_URL,
            headers : {
                "Authorization" : `Bearer ${token}`
            }
        }
    )
    return instance;
}


export default VTAPI;